/* 1. Typography
 *
 * https://app.zeplin.io/project/5c1b2730049de8af82bfd547/screen/5c1f161ca1a063afdb7fbae3
 *
 * */

export default {
  primaryFontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',

  secondaryFontFamily: '"Didot Lt Pro Roman", Didot, times, serif',

  desktop: {
    // CAMPLRGE in zeplin
    campLrg: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 52,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.1538461538,
    },
    // Didot-camplrge in zeplin
    didotCmpLrg: {
      fontFamily: '"Didot Lt Pro Roman", Didot, times, serif',
      fontSize: 52,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.1538461538,
    },
    // CAMPMED in zeplin
    cmpMed: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 41,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.1707317073,
    },
    // Didot-campmed in zeplin
    didotCmpMed: {
      fontFamily: '"Didot Lt Pro Roman", Didot, times, serif',
      fontSize: 41,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.1707317073,
    },
    // didot-heading1 in zeplin
    didotHeading1: {
      fontFamily: '"Didot Lt Pro Roman", Didot, times, serif',
      fontSize: 26,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.5384615385,
    },
    // heading-1 in zeplin
    heading1: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 26,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.5384615385,
    },
    // heading-2 in zeplin
    heading2: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 31,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.1612903226,
    },
    // heading - 3 in zeplin
    heading3: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 20,
      fontWeight: 'normal',
      letterSpacing: 0.3,
      lineHeight: 1.6,
    },
    // heading-3-BOLD in zeplin
    // put here to capture the essence, practically a .bold class could just be added
    heading3Bold: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 20,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.6,
    },
    // heading-4 in zeplin
    heading4: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 18,
      fontWeight: 'normal',
      letterSpacing: 0.3,
      lineHeight: 1.5555555556,
    },
    // heading-4-BOLD in zeplin
    heading4Bold: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 18,
      fontWeight: 'normal',
      letterSpacing: 0.3,
      lineHeight: 1.5555555556,
    },
    // body-copy in zeplin
    bodyCopy: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 16,
      fontWeight: 'normal',
      letterSpacing: 0.3,
      lineHeight: 1.5,
    },
    // BTN-TXT in zeplin
    btnTxt: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 16,
      fontWeight: 'bold',
      letterSpacing: 2.29,
      lineHeight: 1.5,
    },
    // product-txt in zeplin
    productTxt: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 14,
      fontWeight: 'normal',
      letterSpacing: 0.3,
      lineHeight: 1.4285714286,
    },
    // product-txt-BOLD in zeplin
    productTxtBold: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 14,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.4285714286,
    },
    // formfield-tag in zeplin
    formFieldTag: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 12,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.3333333333,
    },
  },
  mobile: {
    // CAMPLRGE is missing in zeplin
    campLrg: {
    },
    // Didot-camplrge is missing in zeplin
    didotCmpLrg: {
    },
    // CAMPMED in zeplin
    cmpMed: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 29,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.3793103448,
    },
    // Didot-campmed in zeplin
    didotCmpMed: {
      fontFamily: '"Didot Lt Pro Roman", Didot, times, serif',
      fontSize: 29,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.3793103448,
    },
    // didot-heading1 in zeplin
    didotHeading1: {
      fontFamily: '"Didot Lt Pro Roman", Didot, times, serif',
      fontSize: 26,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.5384615385,
    },
    // heading-1 in zeplin
    heading1: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 26,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.5384615385,
    },
    // heading-2 in zeplin
    heading2: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 23,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.5652173913,
    },
    // heading - 3 in zeplin
    heading3: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 20,
      fontWeight: 'normal',
      letterSpacing: 0.3,
      lineHeight: 1.6,
    },
    // heading-3-BOLD in zeplin
    heading3Bold: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 20,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.6,
    },
    // heading-4 in zeplin
    heading4: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 18,
      fontWeight: 'normal',
      letterSpacing: 0.3,
      lineHeight: 1.5555555556,
    },
    // heading-4-BOLD in zeplin
    heading4Bold: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 18,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.5555555556,
    },
    // body-copy in zeplin
    bodyCopy: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 16,
      fontWeight: 'normal',
      letterSpacing: 0.3,
      lineHeight: 1.5,
    },
    // BTN-TXT in zeplin
    btnTxt: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 16,
      fontWeight: 'bold',
      letterSpacing: 2.29,
      lineHeight: 1.5,
    },
    // product-txt in zeplin
    productTxt: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 14,
      fontWeight: 'normal',
      letterSpacing: 0.3,
      lineHeight: 1.4285714286,
    },
    // product-txt-BOLD in zeplin
    productTxtBold: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 14,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.4285714286,
    },
    // formfield-tag in zeplin
    formFieldTag: {
      fontFamily: '"proxima nova","helvetica neue",Helvetica,Arial,sans-serif',
      fontSize: 12,
      fontWeight: 'bold',
      letterSpacing: 0.3,
      lineHeight: 1.3333333333,
    },
  },
};
